document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('CartDrawer');
  var overlay = document.getElementById('CartDrawerOverlay');
  var closeBtn = document.getElementById('CartDrawerClose');

  function openDrawer() {
    if (drawer) drawer.classList.add('is-open');
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-open');
  }

  window.CartDrawer = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer };

  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  function refreshDrawer() {
    fetch('/cart?section_id=cart-drawer-content')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newItems = doc.getElementById('CartDrawerItems');
        var newSubtotal = doc.getElementById('CartDrawerSubtotal');
        var newTitle = doc.querySelector('.cart-drawer__title');
        if (newItems) document.getElementById('CartDrawerItems').innerHTML = newItems.innerHTML;
        if (newSubtotal) document.getElementById('CartDrawerSubtotal').innerHTML = newSubtotal.innerHTML;
        if (newTitle) document.querySelector('.cart-drawer__title').innerHTML = newTitle.innerHTML;
        bindItemEvents();
      });
  }

  function changeQuantity(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        refreshDrawer();
      });
  }

  function bindItemEvents() {
    document.querySelectorAll('.cart-drawer__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.dataset.line, 10);
        var valueEl = btn.parentElement.querySelector('.cart-drawer__qty-value');
        var current = parseInt(valueEl.textContent, 10);
        var next = btn.dataset.action === 'increase' ? current + 1 : current - 1;
        changeQuantity(line, Math.max(next, 0));
      });
    });

    document.querySelectorAll('.cart-drawer__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.dataset.line, 10);
        changeQuantity(line, 0);
      });
    });
  }

  bindItemEvents();

  document.addEventListener('cart:added', function () {
    refreshDrawer();
    openDrawer();
  });

  document.querySelectorAll('[data-cart-icon]').forEach(function (icon) {
    icon.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });
});
